<template>
  <div id="noon-form-check-box ">
    <vs-row vs-w="12">
      <div class="aisea-text-14-400-gray mb-2">{{ form.label }}</div>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
        <vs-checkbox
          v-for="(item, index) in form.select_options"
          :key="index"
          v-model="inputValue"
          :vs-value="item.value"
          :color="AISEA_COLOR.BLUE"
          class="mr-4 noon-form-check-box-label-size"
          :class="{'alert-text': item.is_alert }"
        >
          {{ item.label }}
        </vs-checkbox>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import _ from "lodash";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    form: { type: Object, required: true },
    value: { required: false }
  },
  data () {
    return {
      inputValue: [],
      inputValues: [],
    }
  },
  watch: {
    inputValue: {
      handler (val) {
        const payload = {
          id: this.form.id,
        };

        const values = [];
        const labels = [];
        const alertFlgs = [];


        val.forEach(value => {
          this.form.select_options.forEach(option => {
            if (option.value === value) {
              values.push(option.value);
              labels.push(option.label);
              alertFlgs.push(option.is_alert);
            }
          });

        });

        payload.value = values.join(',');
        payload.label = labels.join(',');
        payload.isAlert = alertFlgs.filter(item => item).length > 0;
        this.$emit("setValue", payload)
      },
      deep: true,
    },
  },
  methods: {
    initInputValue () {
      this.inputValues = _.cloneDeep(this.form.select_options);
    },
  },
  created () {
  },

  mounted () {
    if (this.value) {
      this.inputValue = this.value.split(",");
      return;
    } else if (this.form.default_value) {
      this.inputValue = this.form.default_value.split(",");
    }

  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-form-check-box {
  font-size: 1.2rem !important;
}

.noon-form-check-box-label-size {
  font-size: 1.2rem !important;
}
</style>
